// The left edge: what you could make (PLAN-UI §28.3, U4).
//
// Reads `SessionView.hotbar` and hands every click back as an option
// (PLAN-CLIENT-SPLIT day 8): what a tile is, whether it is armed, what it
// costs and why it is off are the engine's to say.

import { Hotbar } from "../HotbarStrip";
import { useFacingAngles } from "../useFacingAngles";
import { useBoardHandle } from "../shell/BoardHandle";
import { useSession, useSessionView } from "../useSessionView";

/**
 * **Hidden for an army that plays no industry, and while watching** — the
 * engine says so with `shown`, and both facts are fixed for the length of the
 * game, so nothing here flickers.
 *
 * The gate is a wrapper rather than an early return inside the tiles, so the
 * facing measurement below stops with the column it feeds. That is safe because
 * `facing` has exactly one reader — the mint dial on the pawn tile — and a
 * watched board has no dial to draw.
 */
export function HotbarZone() {
  const { hotbar } = useSessionView();
  if (!hotbar.shown) return null;
  return <HotbarTiles />;
}

function HotbarTiles() {
  const board = useBoardHandle();
  const session = useSession();
  const { hotbar } = useSessionView();
  // The facing dial is drawn the way the board currently looks — measured off
  // the projection, never derived from `FACING_YAW`.
  const facing = useFacingAngles(board);

  return (
    <Hotbar
      view={hotbar}
      onChoose={(option) => session.choose(option)}
      onLift={(option, at) => session.lift(option, at)}
      facingAngles={facing}
    />
  );
}
